import { safeClone, ViewStream } from "spyne";
import { PageTraits } from "traits/page-traits";
import { BlogTraits } from "traits/blog-traits";
import sdk from "@stackblitz/sdk";

export class PageQuickStart extends ViewStream {
  constructor(props = {}) {
    props.traits = [PageTraits, BlogTraits];
    props.data = safeClone(props.pageData);
    props.isBlog = true;
    props.class = "app-page-docs";
    props.id = "l1-quick-start";
    //console.log('quick start page data ',props.appData);
    props.data.contentLen = PageTraits.page$GetContentLength(props.data);
    //props.template = require("./templates/page-docs.tmpl.html");
    props.template = require("./templates/page-quick-start.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"]];
  }

  broadcastEvents() {
    return [];
  }

  addIframe() {
    sdk.embedProjectId(
      this.props.el$(".docs-content").el,
      "send-info-to-channel",
      {
        openFile: "index.js",
      },
    );
  }

  onRendered() {
    // this.blog$CheckToAddBlogItems();
    this.addChannel("CHANNEL_APP_ROUTE", true);
    this.page$InitPage();
    this.page$checkFor404();
    //this.addIframe();
    //this.appendView(new CodeGeneratorHolder(),  "#code-container");
    //this.appendView(new CodeContainerDetails(), "#code-container");
    //this.appendView(new CodePlaygroundView());
  }
}
